var render = function render(){
  var _vm$user;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('p', {
    staticClass: "page-text primary--text mr-4 mr-lg-10"
  }, [_vm._v(" 보유 포인트: ")]), _c('v-chip', {
    attrs: {
      "color": "grey-f1"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold grey-13--text"
  }, [_vm._v(" " + _vm._s((((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.point) || 0).format()) + "원 ")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }